import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import type { RemixHistoryEntryForUpdate } from '@atlassian/malleable-ui-components/types';

import { remixHistoryPluginKey } from './remix-history-plugin';

export function getHistoryEntryForUpdate({
	state,
	url,
	fieldId,
}: {
	fieldId?: string;
	state: EditorState;
	url?: string;
}): RemixHistoryEntryForUpdate | undefined {
	const remixHistoryState = remixHistoryPluginKey.getState(state);
	const historyMap = remixHistoryState?.historyMap;
	if (!historyMap) {
		return;
	}

	const historyEntry = Object.values(historyMap).find((entry) => {
		const currentStackEntry = entry.stack[entry.currentIndex];

		return (
			(url && currentStackEntry?.url === url) || (fieldId && currentStackEntry?.fieldId === fieldId)
		);
	});

	if (!historyEntry) {
		return;
	}

	const currentStackEntry = historyEntry.stack[historyEntry.currentIndex];
	if (!currentStackEntry) {
		return;
	}

	const historyEntryForUpdate: RemixHistoryEntryForUpdate = {
		conversationId: historyEntry.conversationId,
		dynamicUiSource: historyEntry.dynamicUiSource,
		dynamicUiType: currentStackEntry.dynamicUiType,
		dynamicUiSubtype: currentStackEntry.dynamicUiSubtype,
		finalMessage: currentStackEntry.finalMessage,
		fieldId: currentStackEntry.fieldId,
		url: currentStackEntry.url,
	};

	return historyEntryForUpdate;
}
